<template>
    <div class="courseListItem">
        <!-- <div class="courseCover" :style="'background:url('+courseCover+') no-repeat center'" @click="toDetail(theCourseId,theStudioId,courseName,courseMajorName,courseTeacher)"></div> -->
        <el-image class="courseCover" :src="courseCover" lazy scroll-container="#app" @click="toDetail(theCourseId,theStudioId,courseName,courseMajorName,courseTeacher)"></el-image>
        <div class="courseInfo">
            <div class="p1 ellipsis2">
                <span class="courseType inlineB mr5">{{courseType}}</span>
                <span class="courseLabel inlineB mr5" v-for="(item, index) in courseLabel" :key="index">{{item}}</span>
                <span clas="font16 title">{{courseName}}</span>
            </div>
            <div class="p2 myflex-v">
                <span class="ellipsis1">教师：{{courseTeacher}}</span>
                <span class="marginauto-l nowrap">{{courseMajorName}}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "courseListItem",
    components: {
    },
    props: {
        courseid:{
            default:'',
        },
        studioid:{
           default:'', 
        },
        cover: {
            default: "https://img4.sycdn.imooc.com/szimg/5ad05dc00001eae705400300-360-202.jpg"
        },
        type: {
            default: 1,
        },
        label: {
            default: '',
        },
        name: {
            default: '中国合唱协会网络合唱学院示范课系列之应用和声基础'
        },
        teacher: {
            default: '我是讲师'
        },
        majorname: {
            default: '专业'
        },
    },
    data(){
        return {
            courseCover: art.addOssResize(this.cover,300),
            courseName: this.name,
            courseTeacher: this.teacher,
            courseMajorName: this.majorname,
            theCourseId: this.courseid,
            theStudioId: this.studioid,
        }
    },
    computed: {
        courseType:{
            set(val){
                
            },
            get(val){
                return this.type==1 ? '直播' : '录播';
            }
            
        },
        courseLabel:{
            set(val){
                
            },
            get(val){
                return this.label ? this.label.split(',') : [];
            }
        },
    },
    watch:{
        courseid(val){
            this.theCourseId = val;
        },
        studioid(val){
           this.theStudioId = val;
        },
        cover(val) {
            this.courseCover = art.addOssResize(val,300);
        },
        type(val){
            console.log(val,'type');
            this.courseType = (val==1 ? '直播' : '录播');
        },
        label(val){
            this.courseLabel =  val ? val.split(',') : [];
        },
        name(val) {
            this.courseName = val;
        },
        teacher(val) {
            this.courseTeacher = val;
        },
        majorname(val){
            this.courseMajorName = val;
        },
    },
    methods:{
        //跳转到社区大讲堂详情页面
        toDetail(courseId){
            art.openShequCourseDetail(courseId);
        }
    },
    mounted(){
    }
};
</script>

<style lang="scss" scoped>
    .courseListItem{background:#fff;margin-bottom:20px;-webkit-box-shadow:0 0 21px 0px rgba(0,0,0,.08);box-shadow:0 0 21px 0px rgba(0,0,0,.08);border:1px solid #eee;}
    .courseCover{width:100%;height:192px;background-color:#ebebeb !important;background-size:cover !important;}
    .courseInfo{padding:8px 10px 10px 10px;}
    .courseType{@extend %theme-bg;font-size:12px;padding:3px 6px;color:#fff;text-align:center;line-height:1;}
    .courseLabel{@extend %theme-border;padding:2px 6px;color:$theme-color;text-align:center;font-size:12px;line-height:1;}
    .p1{line-height:1.6;height:46px;}
    .p2{font-size:12px;color:#111;opacity:.6;margin-top:4px;}
    .title{font-weight:600;}
    @media screen and(max-width:560px){
        .p1{-webkit-line-clamp: 3;min-height:69px;}
    }
</style>